// extracted by mini-css-extract-plugin
export default {"Loader":"styles_Loader__prOL9"};